import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import KabobMenu from './KabobMenu';
import BalanceText from './BalanceText';

const useStyles = buildUseStyles('VirtualAccountListItemSecondaryAction', ((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: `${theme.spacing(1)}px`,
  },
})));

const VirtualAccountListItemSecondaryAction = (props) => {
  const { virtualAccountResource } = props;

  const classes = useStyles();

  return (
    <div
      className={classes.root}
    >
      <BalanceText virtualAccountResource={virtualAccountResource} />
      <KabobMenu virtualAccountResource={virtualAccountResource} />
    </div>
  );
};

VirtualAccountListItemSecondaryAction.propTypes = {
  virtualAccountResource: PropTypes.object.isRequired,
};

export default VirtualAccountListItemSecondaryAction;
